<template>
  <b-modal title="Informações Sobre o Relatório Diário" v-model="show" size="lg">
    <b-container fluid>
      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Atividade:" label-for="atv" label-cols-sm="3" label-align="right">
            <b-form-textarea v-model="editing.atividade" rows="2"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Alteração:" label-for="alt" label-cols-sm="3" label-align="right">
            <b-form-textarea v-model="editing.alteracao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Km:" label-for="km" label-cols="3" label-align="right">
            <b-form-input id="km" v-model="editing.km" type="number"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEquipeStore } from "@/stores/EquipeStore";
import Diario from "@/models/Diario";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDeDiario",

  data() {
    return {
      show: false,
      editing: new Diario(0, new Date(), "", "", ""),
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.equipeStore.ALTERAR_DIARIO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Relatório diário salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      } else {
        this.equipeStore.CADASTRAR_DIARIO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Relatório diário salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      }
      this.show = !this.show;
    },

    call(diario) {
      this.show = !this.show;
      this.editing = diario;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();

    return {
      store,
      equipeStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
